module.exports = __webpack_public_path__ + "static/media/motionGrid.c112a47e.gif";